module.exports = __webpack_public_path__ + "static/media/music.d5897cc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music.svg
// module id = 1439
// module chunks = 0